import { FShallowGraph } from '../types/index.js';

import { graphReducer } from './reducer.js';
import { GraphAction } from './types.js';

/**
 * Applies an ordered list of graph actions to a graph state and returns the
 * resulting state, leaving the input state untouched.
 *
 * Replaying a full action log from the initial state and applying each
 * commit's actions incrementally over the previous state are equivalent;
 * this is the replay primitive both paths share.
 */
export const applyActions = <TState extends FShallowGraph, TAction extends GraphAction>(
  state: TState,
  actions: readonly TAction[]
): TState => {
  return actions.reduce(graphReducer, state);
};
